import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactCountdown from 'react-countdown';
import { useViewlogies } from 'context';
import './countdown.scss';
// import CallToAction from './CallToAction';

const zeroPad = num => (num > 99 ? `${num}` : ('0' + num).slice(-2));

const INSTRUCTIONS = [
    {
        id: 'instruction1',
        messageId: 'features.Viewlogy.VideoPlayer.Countdown.instruction1',
        defaultMessage:
            'The live stream will start automatically ON THIS SCREEN. If it does not start automatically, please refresh your page.',
    },
    {
        id: 'instruction2',
        messageId: 'features.Viewlogy.VideoPlayer.Countdown.instruction2',
        defaultMessage:
            'The live stream is a one-way broadcast, therefore, your microphone and video will NOT be shared.',
    },
    {
        id: 'instruction3',
        messageId: 'features.Viewlogy.VideoPlayer.Countdown.instruction3',
        defaultMessage:
            'Your internet browser may automatically mute the audio of the livestream. If that occurs, look for an unmute button on this screen AFTER the livestream starts.',
    },
];

const Countdown = ({ intl, date, hide, hidden = false, obituaryUrl }) => {
    const { isMobile } = useViewlogies();
    const [currentInstructionIndex, setCurrentInstructionIndex] = useState(0);

    // Rotate instructions every 8 seconds (both mobile and desktop)
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentInstructionIndex(prevIndex => (prevIndex + 1) % INSTRUCTIONS.length);
        }, 8000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <>
            <div className={`countdown-container${hidden ? ' hidden' : ''}`}>
                <div className="countdown">
                    {/* <CallToAction /> */}
                    <ReactCountdown
                        date={date}
                        renderer={({ days, hours, minutes }) => (
                            <span>
                                <h2>
                                    <FormattedMessage
                                        id="features.Viewlogy.VideoPlayer.Countdown.willStartIn"
                                        defaultMessage="The private broadcast will be displayed on this screen in:"
                                    />
                                </h2>
                                <div className="countdown-dhm">
                                    <div className="countdown-time-unit">
                                        <h3>
                                            <FormattedMessage
                                                id="features.Viewlogy.VideoPlayer.days"
                                                defaultMessage="days"
                                            />
                                        </h3>
                                        <p className={'countdown-number'}>{zeroPad(days)}</p>
                                    </div>
                                    <div className="countdown-time-unit">
                                        <h3>
                                            <FormattedMessage
                                                id="features.Viewlogy.VideoPlayer.hours"
                                                defaultMessage="hours"
                                            />
                                        </h3>
                                        <p className={'countdown-number'}>{zeroPad(hours)}</p>
                                    </div>
                                    <div className="countdown-time-unit">
                                        <h3>
                                            <FormattedMessage
                                                id="features.Viewlogy.VideoPlayer.minutes"
                                                defaultMessage="minutes"
                                            />
                                        </h3>
                                        <p className={'countdown-number'}>{zeroPad(minutes)}</p>
                                    </div>
                                </div>
                            </span>
                        )}
                    />
                    <div className="countdown-instructions">
                        <h3 className="instructions-title">
                            <FormattedMessage
                                id="features.Viewlogy.VideoPlayer.Countdown.instructionsTitle"
                                defaultMessage="Important things to know before the live stream starts:"
                            />
                        </h3>
                        {/* Show single instruction at a time (both mobile and desktop) */}
                        <div
                            className={`instructions-list instructions-list-carousel ${isMobile ? 'instructions-list-mobile' : 'instructions-list-desktop'}`}
                        >
                            <div className="instruction-item">
                                <span className="instruction-number">{currentInstructionIndex + 1}.</span>
                                <FormattedMessage
                                    id={INSTRUCTIONS[currentInstructionIndex].messageId}
                                    defaultMessage={INSTRUCTIONS[currentInstructionIndex].defaultMessage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="live-caption">
                    <div className="circle" />
                    <div>{'Live'}</div>
                </div>
            </div>
        </>
    );
};

export default injectIntl(Countdown);
